import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { SvuList } from '../../svu/components/SvuList';
import { ManagerMenu } from '../../manager/managermenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const ManagerSvuListPage = () => {
  const { manager, apps } = useSelector((state) => state.app.config);
  return (
    <>
      {apps?.manager && manager?.modules?.svu ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='R7aUrceniEditoraZps'
          action='list.view'
        >
          <SvuList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default ManagerSvuListPage;
